var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTShirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 19.9997C18 20.552 17.5523 20.9997 17 20.9997H7C6.44772 20.9997 6 20.552 6 19.9997V8.99973H3C2.44772 8.99973 2 8.55201 2 7.99973V3.99976C2 3.44746 2.44773 2.99974 3.00003 2.99976L8.47297 2.99991C8.78771 2.99992 9.06713 3.20132 9.16666 3.49991L9.36754 4.10256C9.74524 5.23565 10.8056 5.99992 12 5.99992C13.1944 5.99992 14.2548 5.23565 14.6325 4.10256L14.8333 3.49991C14.9329 3.20132 15.2123 2.99992 15.527 2.99991L21 2.99976C21.5523 2.99974 22 3.44746 22 3.99976V7.99973C22 8.55201 21.5523 8.99973 21 8.99973H18V19.9997Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTShirt);
export default __webpack_public_path__ + "static/media/t-shirt.972b6deb15e90edb1538ae888b939b74.svg";
export { ForwardRef as ReactComponent };